import { extractMetadata } from '@/types/oauth-vault-integration';

const YOUTUBE_CHANNEL_READ = 'https://www.googleapis.com/auth/youtube.readonly';
const YOUTUBE_ANALYTICS_READ = 'https://www.googleapis.com/auth/yt-analytics.readonly';

function grantedScopes(rawData: unknown, platform: string): string[] {
  const scopes = extractMetadata<{ scopes?: string }>(rawData, platform).scopes || '';
  return scopes
    .split(/[,\s]+/)
    .map((scope) => scope.trim())
    .filter(Boolean);
}

export function scopeGapReason(account: { platform: string; rawData: unknown }): string | null {
  if (account.platform === 'tiktok') {
    return grantedScopes(account.rawData, 'tiktok').includes('video.publish')
      ? null
      : 'Needs new permissions to publish videos.';
  }
  if (account.platform === 'youtube') {
    const scopes = grantedScopes(account.rawData, 'youtube');
    return scopes.includes(YOUTUBE_CHANNEL_READ) && scopes.includes(YOUTUBE_ANALYTICS_READ)
      ? null
      : 'Needs YouTube analytics permissions to sync.';
  }
  return null;
}
